import React, {useEffect, useState} from 'react';
import {
    BookOutlined,
    CalendarOutlined,
    ProfileOutlined, ScheduleOutlined,
    RightOutlined, UsergroupAddOutlined
} from "@ant-design/icons/lib";

import Designation from "./setting-table/designation";
import Qualification from "./setting-table/qualification";
import "./../../styles/component/setting.scss"
import {Link, useLocation, Outlet} from "react-router-dom";
import PageHeader from "../../page-components/common/page-header/page-header";


interface ITable {
    key: number,
    label: string,
    route: string,
    leftIcon: React.ReactNode,
    rightIcon: React.ReactNode,
    className: string

}

const SidebarItems: ITable[] = [
    {
        key: 1,
        label: "Leave Types",
        route: 'leave-types',
        leftIcon: <ProfileOutlined className={'left-icon'}/>,
        rightIcon: <RightOutlined className={'right-icon'}/>,
        className: "leave-type",
    },
    {
        key: 2,
        label: "Work Weeks",
        route: 'work-week',
        leftIcon: <CalendarOutlined className={'left-icon'}/>,
        rightIcon: <RightOutlined className={'right-icon'}/>,
        className: "work-weeks",
    },
    {
        key: 3,
        label: "Designation",
        route: 'designation',
        leftIcon: <UsergroupAddOutlined className={'left-icon'}/>,
        rightIcon: <RightOutlined className={'right-icon'}/>,
        className: "designation",
    },

    {
        key: 4,
        label: "Qualification",
        route: 'qualification',
        leftIcon: <BookOutlined className={'left-icon'}/>,
        rightIcon: <RightOutlined className={'right-icon'}/>,
        className: "qualification",
    },

    {
        key: 5,
        label: "Leave Period",
        route: 'leave-period',
        leftIcon: <ScheduleOutlined className={'left-icon'}/>,
        rightIcon: <RightOutlined className={'right-icon'}/>,
        className: "leave-period",
    },
]


const Setting: React.FC = () => {
    const location = useLocation();
    const [table, setTable] = useState<ITable>();

    const checkIfTabActive = (tabRoute: string) => {
        return location.pathname.endsWith(tabRoute);
    }
    useEffect(() => {
        const activeTab = SidebarItems.find((i: any) => checkIfTabActive(i.route));
        if (activeTab) {
            setTable(activeTab);
        } else {
            setTable(SidebarItems[0]);
        }

    }, [])

    const Sidebar = () => {
        return (
            <ul className={'sidebar-item-list'}>
                {
                    SidebarItems.map((item: any, key: any) => {
                        return (
                            <li
                                id={item.key}
                                key={item.key}
                                className={`sidebar-item ${item.className}` + (checkIfTabActive(item.route) ? " active" : "")}
                            >
                                <Link to={item.route}
                                      onClick={() => setTable(item)}
                                >
                                    {item.leftIcon}
                                    {item.label}
                                    {item.rightIcon}
                                </Link>
                            </li>
                        )
                    })
                }
            </ul>
        )
    }


    return (
        <div>
            <PageHeader title={'Settings'}
                        description={'Manage system configurations, master data, and organizational settings'}
            />
            <Sidebar/>
            <Outlet/>
        </div>


    );
}

export default Setting;
